import { getErrorObjectsList } from '@shared/utils/helpers';
import { ErrorMessageStrategy, ResponseError } from '@shared/utils/interfaces';

export const serviceDoesntExistsStrategy: ErrorMessageStrategy = (error: ResponseError) => {
  const productsList = getErrorObjectsList(error);

  return {
    translationKey: 'errors.SERVICE_DOESNT_EXISTS',
    translationParams: {
      products: productsList,
    },
  };
};
